import { AVAILABLE_SURVEY_REPLY } from "../actions/types";

let surveyReplyDataState = { surveyReplies: [], totalPages: 0, currentPage: 1 };

export default function (state = surveyReplyDataState, action) {

    switch (action.type) {
        case AVAILABLE_SURVEY_REPLY:
            if (state.surveyReplies.length === 0) {
                return {
                    ...state,
                    surveyReplies: action.payload.content.replies,
                    totalPages: action.payload.content.totalPages,
                    currentPage: parseInt(action.payload.content.currentPage),
                }
            } else {
                let concatResult = {};
                concatResult.surveyReplies = state.surveyReplies.concat(action.payload.content.replies);
                concatResult.totalPages = action.payload.content.totalPages;
                concatResult.currentPage = parseInt(action.payload.content.currentPage);
                return {
                    ...state,
                    surveyReplies: concatResult.surveyReplies,
                    totalPages: concatResult.totalPages,
                    currentPage: concatResult.currentPage,
                }
            }

        default:
            return state;
    }
}

